import styled from 'styled-components'
import { Text } from 'components'
import { GLOBAL_COLORS } from 'theme'

export const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  cursor: pointer;
`

interface TooltipBodyProps {
  color?: string
  fontColor?: string
  infoIcon: boolean
  customPadding?: string
  openLeftSide?: boolean
  openLeftAmount?: string
  openRightAmount?: string
  outOfBoundsTop?: boolean
  outOfBoundsBottom?: boolean
  outOfBoundsLeft?: boolean
  outOfBoundsRight?: boolean
}

export const TooltipBody = styled.div<TooltipBodyProps>`
  background-color: ${(props) => (props.color ? props.color : GLOBAL_COLORS.tidalBlue)};
  color: ${(props) => (props.fontColor ? props.fontColor : GLOBAL_COLORS.white)};
  width: max-content;
  min-width: auto;
  max-width: 160px;
  position: absolute;
  margin-top: 12px;
  ${(props) =>
    props.openLeftSide
      ? `right:  ${props.openRightAmount ? props.openRightAmount : '-100%'}`
      : `left: ${props.openLeftAmount ? props.openLeftAmount : '-30px'}`};
  transform: translateX(-50%);
  transform: translateY(5px);
  ${(props) =>
    props.infoIcon &&
    `transform: translateX(50%);
    transform: translateY(2px);
  `};
  padding: ${({ customPadding }) => (customPadding ? customPadding : '15px')};
  z-index: 2;
  border-radius: 8px;
  ${(props) => props.outOfBoundsBottom && `bottom: 32px;`};
`
export const Triangle = styled.div<{
  openLeftSide?: boolean
  outOfBoundsTop?: boolean
  outOfBoundsBottom?: boolean
  outOfBoundsLeft?: boolean
  outOfBoundsRight?: boolean
}>`
  content: '';
  position: absolute;
  top: -12px;
  ${(props) => props.openLeftSide && `right: 24px`};
  ${(props) =>
    props.outOfBoundsBottom &&
    `
    bottom: -12px;
    top: unset;
    transform: rotate(180deg);
  `};
  border-bottom: 12px solid ${GLOBAL_COLORS.tidalBlue};
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
`

export const StyledTitle = styled(Text)`
  margin: 0px;
  text-align: left;
  color: ${GLOBAL_COLORS.seashellWhite};
`

export const StyledText = styled(Text)`
  margin: 0px;
  text-align: left;
  color: ${GLOBAL_COLORS.seashellWhite};
`
